import gt from './gt.js';

/**
 * Ge.
 *
 * @param {number} n
 * @param {Iterable} iterable
 */
const ge = (n, iterable) => gt(n - 1, iterable);
export default ge;
